import { FC, PropsWithChildren, useState } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/_atoms/dialog";

import { TeamBrowseList } from "./team-browse-list";

interface TeamBrowseAllDialogProps extends PropsWithChildren {
  asChild?: boolean;
  className?: string;
  workspaceId: string;
  userId: string;
}

export const TeamBrowseAllDialog: FC<TeamBrowseAllDialogProps> = ({
  children,
  asChild,
  className,
  workspaceId,
  userId,
}) => {
  const [dialogisOpen, setDialogisOpen] = useState(false);

  function onDialogOpenChange(open: boolean) {
    setDialogisOpen(open);
  }

  return (
    <>
      <Dialog open={dialogisOpen} onOpenChange={onDialogOpenChange}>
        <DialogTrigger asChild={asChild} className={className}>
          {children}
        </DialogTrigger>
        <DialogContent className="top-[1%] max-h-[99vh] max-w-xl translate-y-[0%] overflow-y-scroll md:top-[10%] md:max-h-[80vh]">
          <DialogHeader>
            <DialogTitle>Teams durchsuchen</DialogTitle>
            <DialogDescription>Durchsuchen und treten Sie Teams in Ihrem Workspace bei.</DialogDescription>
          </DialogHeader>
          <TeamBrowseList workspaceId={workspaceId} userId={userId} />
        </DialogContent>
      </Dialog>
    </>
  );
};
